import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PrBuyerHelperService } from '../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-rc-image-display',
  templateUrl: './rc-image-display.component.html',
  // template: `<img border="0" width="50" height="50" [src]="imagePath">`,
  styleUrls: ['./rc-image-display.component.scss']
})
export class RcImageDisplayComponent implements OnInit {

  constructor(private _sanitizer: DomSanitizer, private _prBuyerHelperService: PrBuyerHelperService,) { }

  ngOnInit(): void {
  }

  public isImage:boolean = false;
  imagePath: any;
  agInit(params: any){
    this.isImage = params.value ? true : false;
    this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'+params.value); 
  }

  public openImage(){
    this._prBuyerHelperService.openRCImage(this.imagePath);
  }
}
